<template>
  <div v-if="$can('view-finance', 'Yacht')">
    finance
  </div>
</template>

<script>
export default {
  name: 'Finance'
}
</script>

<style scoped>

</style>
